import { render, staticRenderFns } from "./Advice.vue?vue&type=template&id=fd3d76dc&scoped=true&"
import script from "./Advice.vue?vue&type=script&lang=js&"
export * from "./Advice.vue?vue&type=script&lang=js&"
import style0 from "./Advice.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Advice.vue?vue&type=style&index=1&id=fd3d76dc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd3d76dc",
  null
  
)

export default component.exports